import { useEffect } from "react";
import { Button, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import AssignedComapnies from "./AssignedComapnies";
import CreatedCompanies from "./CreatedCompanies";

const MyCompanies = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const navigate = useNavigate();
  // Set default tab to "created" if not present
  useEffect(() => {
    if (!tab) {
      setSearchParams({ tab: "created" });
    }
  }, [tab, setSearchParams]);

  const handleSelect = (key) => {
    setSearchParams({ tab: key });
  };
  const handleNavigate = () => {
    navigate("/dashboard/creditPassBook?tab=organization");
  };
  return (
    <div
      className="scrollable-container"
      style={{
        height: "100%",
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1>
          <strong>My Companies</strong>
        </h1>
        <Button onClick={handleNavigate}>Back</Button>
      </div>
      <Tabs
        activeKey={tab || "created"}
        onSelect={handleSelect}
        id="my-companies-tabs"
        className="mb-3"
      >
        <Tab eventKey="created" title="Created Companies">
          <CreatedCompanies />
        </Tab>
        <Tab eventKey="assigned" title="Assigned Companies">
          <AssignedComapnies />
        </Tab>
      </Tabs>
    </div>
  );
};

export default MyCompanies;
